export class DatePickerUtils {
  public static addPaddingToDatesFields(value: number | string, size: number): string {
    return String(value).padStart(size, '0');
  }

  public static addPaddingToYearFields(value: number | string, size: number): string {
    return String(value).padStart(size, '20');
  }
}
